module.exports = __webpack_public_path__ + "img/meal-go.1c74874b.png";